import { render, staticRenderFns } from "./TenderRepresentative.vue?vue&type=template&id=2658994c&"
import script from "./TenderRepresentative.vue?vue&type=script&lang=js&"
export * from "./TenderRepresentative.vue?vue&type=script&lang=js&"
import style0 from "./TenderRepresentative.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2658994c')) {
      api.createRecord('2658994c', component.options)
    } else {
      api.reload('2658994c', component.options)
    }
    module.hot.accept("./TenderRepresentative.vue?vue&type=template&id=2658994c&", function () {
      api.rerender('2658994c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/view/TenderRepresentative.vue"
export default component.exports